var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEventMenuShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.33301C14 5.43757 13.1046 6.33301 12 6.33301C10.8954 6.33301 10 5.43757 10 4.33301C10 3.22844 10.8954 2.33301 12 2.33301C13.1046 2.33301 14 3.22844 14 4.33301Z",
    stroke: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8C6 9.1046 5.10457 10 4 10C2.89543 10 2 9.1046 2 8C2 6.8954 2.89543 6 4 6C5.10457 6 6 6.8954 6 8Z",
    stroke: "#616161"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.667C14 12.7716 13.1046 13.667 12 13.667C10.8954 13.667 10 12.7716 10 11.667C10 10.5624 10.8954 9.66699 12 9.66699C13.1046 9.66699 14 10.5624 14 11.667Z",
    stroke: "#616161"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81909 7.16666L10.1524 5.16699M5.81909 8.83366L10.1524 10.8333",
    stroke: "#616161"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventMenuShare);
export default __webpack_public_path__ + "static/media/event_menu_share.3ba2087ba4bc47d0065ccd47332c8794.svg";
export { ForwardRef as ReactComponent };